const AmountScreen = ({ amount, setAmount, onNext }) => (
  <div className="bg-white shadow-md p-6 rounded-2xl border">
    <h2 className="text-xl font-semibold text-[#003399] mb-4">Enter Amount</h2>

    <input
      type="number"
      value={amount}
      onChange={(e) => setAmount(e.target.value)}
      placeholder="Enter amount"
      className="w-full p-3 border rounded-lg focus:ring-[#003399] focus:border-[#003399]"
    />

    <button
      onClick={onNext}
      disabled={!amount}
      className="w-full mt-5 bg-[#ED6E0A] text-white py-3 rounded-lg hover:opacity-90 disabled:opacity-50"
    >
      Continue
    </button>
  </div>
);

export default AmountScreen;